"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _childrenToArray = _interopRequireDefault(require("../_util/childrenToArray"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const spaceSize = {
  l: 8,
  ll: 16,
  lll: 24,
  llll: 32,
  lllll: 40
};
const Space = props => {
  const {
    size = 'l',
    columnGap,
    rowGap,
    align,
    children,
    direction = 'horizontal',
    wrap = 'nowrap',
    splitLine = false,
    isEmptyShow,
    block = false,
    itemWidth,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-space");
  const items = (0, _childrenToArray.default)(children, isEmptyShow);
  const len = items.length;
  if (len === 0) {
    return null;
  }
  const mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
  const cn = (0, _classnames.default)(baseClassName, "".concat(baseClassName, "-").concat(direction), {
    ["".concat(baseClassName, "-block")]: block,
    ["".concat(baseClassName, "-align-").concat(mergedAlign)]: !!mergedAlign,
    ["".concat(baseClassName, "-wrap-").concat(wrap)]: !!wrap
  }, className);
  const itemClassName = "".concat(baseClassName, "-item");
  const splitClassName = "".concat(baseClassName, "-split");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...restProps,
    className: cn,
    style: {
      columnGap: columnGap !== null && columnGap !== void 0 ? columnGap : typeof size === 'string' ? spaceSize[size] : size,
      rowGap: rowGap !== null && rowGap !== void 0 ? rowGap : typeof size === 'string' ? spaceSize[size] : size,
      ...style
    },
    children: items === null || items === void 0 ? void 0 : items.flatMap((child, i) => {
      let key = "".concat(itemClassName, "-").concat(i);
      if ( /*#__PURE__*/React.isValidElement(child) && child.key !== undefined && child.key !== null) {
        key = child.key;
      }
      const elements = [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: itemClassName,
        style: itemWidth ? {
          width: typeof itemWidth === 'object' ? itemWidth[i] : itemWidth
        } : undefined,
        children: child
      }, key)];
      if (splitLine && i > 0) {
        elements.unshift( /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: splitClassName
        }, "".concat(splitClassName, "-").concat(i)));
      }
      return elements;
    })
  });
};
var _default = exports.default = Space;